<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Stock de bins por condición</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="stockStateListHeaders"
          :items="stockStateListBody"
          class="elevation-3"
          no-data-text="No hay datos"
          :hide-default-footer="true"
          disable-pagination
        >
          <template slot="body.append">
            <tr class="primary--text">
              <th class="title text-center">Totales</th>
              <th class="title text-center">
                  {{ sumaColumna('a800') }}
              </th>
              <th class="title text-center">
                  {{ sumaColumna('a1000') }}
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      url_excel: '',
      isLoading: false,
      stockStateListHeaders: [],
      stockStateListBody: [],
    }),
    mounted() {
      this.loadStateStockReport();
    },
    methods:{
      sumaColumna(key) {
        let total = 0;
        this.stockStateListBody.forEach(row => {
            total += parseInt(row[key]);
        });
        return total;
      },
      async loadStateStockReport(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}bins/report/state`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.stockStateListHeaders = response.data.data.headers;
          this.stockStateListBody = response.data.data.body;
          this.url_excel = this.storage_url + response.data.data.url_excel;
          this.ocultarLoading();
        }).catch((error)=>{
          console.log(error);
          this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      
    }
  }
</script>